// soAddressFill.ts — 2026-10-03.
//
// Contact.address and Account.billingAddress are Json columns: a plain string
// on old rows, an object ({ line1, city, state, pincode } …) on new ones. The
// Sales Order editor's Contact auto-fill put a Contact's OBJECT address into
// line1, so the Address Line 1 box read "[object Object]". This turns either
// shape into the editor's address fields.

export interface AddressFields {
  line1?: string;
  line2?: string;
  city?: string;
  state?: string;
  pincode?: string;
}

const text = (v: unknown): string | undefined => {
  if (typeof v === 'number') return String(v);
  if (typeof v !== 'string') return undefined;
  const s = v.trim();
  return s === '' ? undefined : s;
};

/** Null when there is nothing usable — the caller keeps what the form had. */
export function addressFieldsFromJson(v: unknown): AddressFields | null {
  if (typeof v === 'string') {
    const s = v.trim();
    return s === '' ? null : { line1: s };
  }
  if (!v || typeof v !== 'object' || Array.isArray(v)) return null;
  const o = v as Record<string, unknown>;
  const out: AddressFields = {};
  const line1 = text(o.line1) ?? text(o.street) ?? text(o.address);
  const line2 = text(o.line2);
  const city = text(o.city) ?? text(o.district);
  const state = text(o.state) ?? text(o.stateName);
  const pincode = text(o.pincode) ?? text(o.zip) ?? text(o.pin);
  if (line1) out.line1 = line1;
  if (line2) out.line2 = line2;
  if (city) out.city = city;
  if (state) out.state = state;
  if (pincode) out.pincode = pincode;
  return Object.keys(out).length === 0 ? null : out;
}
